import React, { useEffect, useState } from "react";
import "../styles/styles.css";
import {
  Card,
  Typography,
  Avatar,
  Select,
  Button,
  DatePicker,
  Row,
  Col,
  Table,
  Spin,
  message,
  Collapse,
  TimePicker
} from "antd";
import {
  UserOutlined,
  AppstoreOutlined,
  DollarOutlined,
  FundOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import instance from "../utils/axiosInstance";
import dayjs from "dayjs";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const Dashboard = () => {
  // Initialize selectedFilterDate with the current date
  const [selectedFilterDate, setSelectedFilterDate] = useState(dayjs().format("DD-MM-YYYY"));
  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [fundRequests, setFundRequests] = useState([]);
  const [gamesList, setGamesList] = useState([]);
  const [starlineData, setStarlineData] = useState({ totalAmount: 0 });
  const [mainMarketData, setMainMarketData] = useState({ totalAmount: 0 });
  const [autoDepositHistory, setAutoDepositHistory] = useState([]);
  const [totalUsers, setTotalUsers] = useState({ totalUsers: 0 });
  const [approvedUsers, setApprovedUsers] = useState({ approvedUsers: 0 });
  const [unapprovedUsers, setUnApprovedUsers] = useState({ unapprovedUsers: 0 });
  const [data, setData] = useState([]);
  const [totalGames, setTotalGames] = useState({ totalGameCount: 0 });
  const [mainMarketGamesList, setMainMarketGamesList] = useState([]);
  const [mainMarketGamesListLeft, setMainMarketGamesListLeft] = useState([]);
  const [selectedGame, setSelectedGame] = useState("");
  const [selectedSession, setSelectedSession] = useState("");
  const [error, setError] = useState(null);
  const [profitLossData, setProfitLossData] = useState([]);
  const [dashboardData2, setDashboardData2] = useState({
    totalBidAmount: 0,
    totalWinAmount: 0,
    totalProfitAmount: 0,
  });
  const [selectedDate, setSelectedDate] = useState(dayjs().format("DD-MM-YYYY"));
  const [selectedGame2, setSelectedGame2] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButton2, setLoadingButton2] = useState(false);
  const [loadingButton3, setLoadingButton3] = useState(false);
  const [withdrawalHistory, setWithdrawalHistory] = useState([]);
  const [betRates, setBetRates] = useState([]);
  const [selectedGameType, setSelectedGameType] = useState("");
  const [showAutoDepositHistory, setShowAutoDepositHistory] = useState(false);
  const [showManualDeposits, setShowManualDeposits] = useState(false);
  const [showWithdrawals, setShowWithdrawals] = useState(false);
  const [showFundRequests, setShowFundRequests] = useState(false);
  const [totalAutoDeposit, setTotalAutoDeposit] = useState(0);
  const [totalManualDeposit, setTotalManualDeposit] = useState(0);
  const [dateTotalAutoDeposit, setDateTotalAutoDeposit] = useState(0);
  const [dateTotalManualDeposit, setDateTotalManualDeposit] = useState(0);
  const [adminData, setAdminData] = useState({
    totalMainMarketBidAmount: 0,
    totalStarlineBidAmount: 0,
    totalGaliDisawarBidAmount: 0,
    dateTotalBidAmount: 0,
    dateWithdrawalAmount: 0,
  });

  const [loginStats, setLoginStats] = useState({
    todayLoginCount: 0,
    totalActiveSessions: 0
  });

  const [registrationStats, setRegistrationStats] = useState({
    todayRegistrations: 0,
    totalRegistrations: 0
  });

  // New state for market refresh time
  const [marketRefreshTime, setMarketRefreshTime] = useState(null);
  const [updatingRefreshTime, setUpdatingRefreshTime] = useState(false);

  const navigate = useNavigate();

  const fetchLoginStats = async () => {
    try {
      const response = await instance.get('/api/session/admin/login-stats');
      if (response.data.success) {
        setLoginStats({
          todayLoginCount: response.data.todayLoginCount,
          totalActiveSessions: response.data.totalActiveSessions
        });
      }
    } catch (error) {
      console.error('Error fetching login stats:', error);
    }
  };

  const fetchRegistrationStats = async () => {
    try {
      const response = await instance.get('/api/session/admin/registration-stats');
      if (response.data.success) {
        setRegistrationStats({
          todayRegistrations: response.data.todayRegistrations,
          totalRegistrations: response.data.totalRegistrations
        });
      }
    } catch (error) {
      console.error('Error fetching registration stats:', error);
    }
  };

  // Handler for Global Date Filter
  const handleFilterDateChange = (date) => {
    if (date) {
      const formattedDate = dayjs(date).format("DD-MM-YYYY");
      setSelectedFilterDate(formattedDate);
    } else {
      // Revert to current date when cleared
      setSelectedFilterDate(dayjs().format("DD-MM-YYYY"));
    }
  };

  // Handler for Market Bid Details DatePicker
  const handleDateChange2 = (date) => {
    if (date) {
      const formattedDate = dayjs(date).format("DD-MM-YYYY");
      setSelectedDate(formattedDate);
    } else {
      // Revert to current date or global filter date
      setSelectedDate(selectedFilterDate || dayjs().format("DD-MM-YYYY"));
    }
  };

  // Fetch Manual Deposits
  const fetchDeposits = async () => {
    try {
      setLoading(true);
      const url = selectedFilterDate
        ? `/api/manualDeposit?date=${selectedFilterDate}`
        : `/api/manualDeposit`;
      const res = await instance.get(url);
      if (selectedFilterDate) {
        setData(
          (res.data || []).filter((record) =>
            moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
          )
        );
      } else {
        setData(res.data || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error("Failed to fetch deposit transactions");
      try {
        const res = await instance.get("/api/manualDeposit");
        if (selectedFilterDate) {
          setData(
            (res.data || []).filter((record) =>
              moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
            )
          );
        } else {
          setData(res.data || []);
        }
      } catch (fallbackError) {
        console.error("Fallback fetch failed:", fallbackError);
      }
    }
  };

  useEffect(() => {
    fetchDeposits();
    fetchLoginStats();
    fetchRegistrationStats();
  }, [selectedFilterDate]);

  // Handler for game selection
  const handleGameChange2 = (value) => {
    setSelectedGame2(value);
  };

  // Submit handler for market bid details
  const handleSubmit = async () => {
    if (!selectedDate || !selectedGame2) {
      message.error("Please select both a date and a game name.");
      return;
    }
    try {
      setLoadingButton(true);
      const requestBody = {
        gameName: selectedGame2,
        date: selectedDate,
      };

      const response = await instance.post(
        `/api/mainmarketdeclareResult/get-total-winnings`,
        requestBody
      );

      const { totalPoints, totalWinningPoints } = response.data;
      const totalProfitAmount = totalPoints - totalWinningPoints;

      setDashboardData2({
        totalBidAmount: totalPoints,
        totalWinAmount: totalWinningPoints,
        totalProfitAmount,
      });
    } catch (error) {
      console.error("Error fetching total winnings:", error);
      message.error("Error fetching total winnings");
    } finally {
      setLoadingButton(false);
    }
  };

  // Fetch Total, Approved, and Unapproved Users
  const fetchTotalUsers = async () => {
    try {
      const response = await instance.get(`/api/app/users`);
      const data = response.data;
      setTotalUsers({ totalUsers: data.totalUsers || 0 });
    } catch (error) {
      console.error("Error fetching total users:", error);
    }
  };

  const fetchApprovedUsers = async () => {
    try {
      const response = await instance.get(`/api/app/users`);
      const data = response.data;
      setApprovedUsers({ approvedUsers: data.approvedUsers || 0 });
    } catch (error) {
      console.error("Error fetching approved users:", error);
    }
  };

  const fetchUnApprovedUsers = async () => {
    try {
      const response = await instance.get(`/api/app/users`);
      const data = response.data;
      setUnApprovedUsers({ unapprovedUsers: data.unapprovedUsers || 0 });
    } catch (error) {
      console.error("Error fetching unapproved users:", error);
    }
  };

  useEffect(() => {
    fetchTotalUsers();
    fetchApprovedUsers();
    fetchUnApprovedUsers();
  }, []);

  // Fetch Auto Deposit History
  useEffect(() => {
    const fetchDepositHistory = async () => {
      try {
        setLoading(true);
        const url = selectedFilterDate
          ? `/api/userPayment/getpaymentResponse?date=${selectedFilterDate}`
          : `/api/userPayment/getpaymentResponse`;
        const response = await instance.get(url);
        if (selectedFilterDate) {
          setAutoDepositHistory(
            (response.data.data || []).filter((record) =>
              moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
            )
          );
        } else {
          setAutoDepositHistory(response.data.data || []);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching deposit history:", err);
        setError("Failed to fetch deposit history. Please try again.");
        setLoading(false);
        // Fallback
        try {
          const response = await instance.get(`/api/userPayment/getpaymentResponse`);
          if (selectedFilterDate) {
            setAutoDepositHistory(
              (response.data.data || []).filter((record) =>
                moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
              )
            );
          } else {
            setAutoDepositHistory(response.data.data || []);
          }
        } catch (fallbackError) {
          console.error("Fallback fetch failed:", fallbackError);
        }
      }
    };

    fetchDepositHistory();
  }, [selectedFilterDate]);

  // Handlers for bid summary
  const handleGameChange = (value) => {
    setSelectedGame(value);
  };

  const handleSessionChange = (value) => {
    setSelectedSession(value);
  };

  const handleGetClick = async () => {
    if (!selectedGame || !selectedSession || !selectedGameType) {
      message.error("Please select a game name, session, and game type");
      return;
    }

    let openFlag = selectedSession === "open";
    let closeFlag = selectedSession === "close";

    const body = {
      gameName: selectedGame,
      open: openFlag,
      close: closeFlag,
      gameType: selectedGameType,
      date: selectedFilterDate || dayjs().format("DD-MM-YYYY"),
    };

    try {
      setLoadingButton2(true);
      const response = await instance.post(`/api/bid/todayDigitSummary`, body);
      if (response.data && response.data.data) {
        setDashboardData(response.data.data);
      } else {
        message.error("Invalid response from server");
      }
    } catch (error) {
      console.error("Error fetching bid summary:", error);
      message.error("Error fetching bid summary");
    } finally {
      setLoadingButton2(false);
    }
  };

  // Fetch Main Market Games
  useEffect(() => {
    const fetchGames = async () => {
      try {
        setLoadingButton2(true);
        const response = await instance.get(`/api/marketManagement/getMarketGames`);
        if (Array.isArray(response.data)) {
          const filteredGames = response.data.filter(
            (game) => game.marketName === "Main Market"
          );
          setMainMarketGamesList(filteredGames);
          setMainMarketGamesListLeft(filteredGames);
        } else {
          console.error("Response data is not an array:", response.data);
        }
      } catch (error) {
        console.error("Error fetching market games:", error);
      } finally {
        setLoadingButton2(false);
      }
    };

    fetchGames();
  }, []);

  // Fetch Bet Rates
  useEffect(() => {
    const fetchBetRates = async () => {
      try {
        setLoading(true);
        const response = await instance.get("api/rates/getBetRates");
        if (response.data && typeof response.data === "object") {
          const { _id, createdAt, updatedAt, __v, ...filteredData } = response.data;
          const cleanedData = Object.keys(filteredData)
            .filter((key) => !key.includes("Value"))
            .reduce((acc, key) => {
              acc[key] = filteredData[key];
              return acc;
            }, {});
          setBetRates(Object.keys(cleanedData));
        } else {
          console.error("Invalid response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching bet rates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBetRates();
  }, []);

  const mainMarketGames = mainMarketGamesList.filter(
    (game) => game.marketName === "Main Market"
  );

  const mainMarketGamesLeft = mainMarketGamesListLeft.filter(
    (game) => game.marketName === "Main Market"
  );

  // Fetch Dashboard Data, Fund Requests, and Games List
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const url = selectedFilterDate
          ? `/api/admin/dashboard?date=${selectedFilterDate}`
          : `/api/admin/dashboard`;
        const response = await instance.get(url);
        setDashboardData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
      setLoading(false);
    };

    const fetchFundRequests = async () => {
      try {
        const url = selectedFilterDate
          ? `/api/admin/fundRequests?date=${selectedFilterDate}`
          : `/api/admin/fundRequests`;
        const response = await instance.get(url);
        if (selectedFilterDate) {
          setFundRequests(
            (response.data || []).filter((record) =>
              moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
            )
          );
        } else {
          setFundRequests(response.data || []);
        }
      } catch (error) {
        console.error("Error fetching fund requests:", error);
        // Fallback
        try {
          const response = await instance.get(`/api/admin/fundRequests`);
          if (selectedFilterDate) {
            setFundRequests(
              (response.data || []).filter((record) =>
                moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
              )
            );
          } else {
            setFundRequests(response.data || []);
          }
        } catch (fallbackError) {
          console.error("Fallback fetch failed:", fallbackError);
        }
      }
    };

    const fetchGamesList = async () => {
      try {
        const response = await instance.get(`/api/gameRoutes/getGameList`);
        if (Array.isArray(response.data)) {
          setGamesList(response.data);
        } else {
          setGamesList([]);
          console.error("Expected array, received:", response.data);
        }
      } catch (error) {
        console.error("Error fetching games list:", error);
        setGamesList([]);
      }
    };

    fetchDashboardData();
    fetchFundRequests();
    fetchGamesList();
  }, [selectedFilterDate]);

  // Fetch Starline, Main Market Bid Amount, and Total Games
  const fetchStarlineData = async () => {
    try {
      const url = selectedFilterDate
        ? `/api/starlinebid/starline-total-bid-amount?date=${selectedFilterDate}`
        : `/api/starlinebid/starline-total-bid-amount`;
      const response = await instance.get(url);
      const data = response.data;
      setStarlineData({ totalAmount: data.totalAmount || 0 });
    } catch (error) {
      console.error("Error fetching Starline bid amount:", error);
      // Fallback
      try {
        const response = await instance.get(`/api/starlinebid/starline-total-bid-amount`);
        const data = response.data;
        if (selectedFilterDate) {
          setStarlineData({
            totalAmount: (data || []).filter((record) =>
              moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
            ).reduce((sum, record) => sum + (record.points || 0), 0),
          });
        } else {
          setStarlineData({
            totalAmount: (data || []).reduce((sum, record) => sum + (record.points || 0), 0),
          });
        }
      } catch (fallbackError) {
        console.error("Fallback fetch failed:", fallbackError);
      }
    }
  };

  const fetchMainMarketData = async () => {
    try {
      const url = selectedFilterDate
        ? `/api/bid/getAllBid?date=${selectedFilterDate}`
        : `/api/bid/getAllBid`;
      const response = await instance.get(url);
      const data = response.data;
      setMainMarketData({ totalAmount: data.totalAmount || 0 });
    } catch (error) {
      console.error("Error fetching Main Market bid amount:", error);
      // Fallback
      try {
        const response = await instance.get(`/api/bid/getAllBid`);
        const data = response.data;
        if (selectedFilterDate) {
          setMainMarketData({
            totalAmount: (data || []).filter((record) =>
              moment(record.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
            ).reduce((sum, record) => sum + (record.points || 0), 0),
          });
        } else {
          setMainMarketData({
            totalAmount: (data || []).reduce((sum, record) => sum + (record.points || 0), 0),
          });
        }
      } catch (fallbackError) {
        console.error("Fallback fetch failed:", fallbackError);
      }
    }
  };

  const fetchTotalGames = async () => {
    try {
      const response = await instance.get(`/api/marketManagement/games/totalCount`);
      const data = response.data;
      setTotalGames({ totalGameCount: data.totalGameCount || 0 });
    } catch (error) {
      console.error("Error fetching total games:", error);
    }
  };

  useEffect(() => {
    fetchMainMarketData();
    fetchStarlineData();
    fetchTotalGames();
  }, [selectedFilterDate]);

  // Fetch Profit/Loss Data
  useEffect(() => {
    const fetchProfitLossData = async () => {
      try {
        setLoadingButton3(true);
        setError(null);
        const url = selectedFilterDate
          ? `/api/users/total-profit-loss?date=${selectedFilterDate}`
          : `/api/users/total-profit-loss`;
        const response = await instance.get(url);
        if (response.data && response.data.success) {
          const totalDeposit = response.data.totalDeposit || 0;
          const totalWithdraw = response.data.totalWithdraw || 0;
          const total = totalDeposit - totalWithdraw;
          setProfitLossData([
            {
              key: 1,
              deposit: totalDeposit,
              withdraw: totalWithdraw,
              total: total,
              result: total,
            },
          ]);
        } else {
          setError("Error: Could not fetch profit/loss data.");
        }
      } catch (err) {
        console.error("Error fetching profit/loss data:", err);
        setError("Error fetching profit/loss data");
        // Fallback
        try {
          const response = await instance.get(`/api/users/total-profit-loss`);
          if (response.data && response.data.success) {
            const totalDeposit = response.data.totalDeposit || 0;
            const totalWithdraw = response.data.totalWithdraw || 0;
            const total = totalDeposit - totalWithdraw;
            setProfitLossData([
              {
                key: 1,
                deposit: totalDeposit,
                withdraw: totalWithdraw,
                total: total,
                result: total,
              },
            ]);
          }
        } catch (fallbackError) {
          console.error("Fallback fetch failed:", fallbackError);
        }
      } finally {
        setLoadingButton3(false);
      }
    };

    fetchProfitLossData();
  }, [selectedFilterDate]);

  // Fetch Withdrawals
  useEffect(() => {
    const fetchWithdrawals = async () => {
      setLoading(true);
      try {
        const url = selectedFilterDate
          ? `/api/users/todaywithdrawals?date=${selectedFilterDate}`
          : `/api/users/todaywithdrawals`;
        const response = await instance.get(url);
        if (selectedFilterDate) {
          const pendingWithdrawals = (response.data || []).filter(
            (withdrawal) =>
              withdrawal.status === "pending" &&
              moment(withdrawal.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
          );
          setWithdrawalHistory(pendingWithdrawals);
        } else {
          const pendingWithdrawals = (response.data || []).filter(
            (withdrawal) => withdrawal.status === "pending"
          );
          setWithdrawalHistory(pendingWithdrawals);
        }
      } catch (err) {
        console.error("Error fetching withdrawal requests:", err);
        setError("Failed to fetch withdrawal requests.");
        // Fallback
        try {
          const response = await instance.get(`/api/users/todaywithdrawals`);
          if (selectedFilterDate) {
            const pendingWithdrawals = (response.data || []).filter(
              (withdrawal) =>
                withdrawal.status === "pending" &&
                moment(withdrawal.createdAt || new Date()).format("DD-MM-YYYY") ===
                selectedFilterDate
            );
            setWithdrawalHistory(pendingWithdrawals);
          } else {
            const pendingWithdrawals = (response.data || []).filter(
              (withdrawal) => withdrawal.status === "pending"
            );
            setWithdrawalHistory(pendingWithdrawals);
          }
        } catch (fallbackError) {
          console.error("Fallback fetch failed:", fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchWithdrawals();
  }, [selectedFilterDate]);

  // Handle Withdrawal Status Change
  const handleStatusChange = async (id, status) => {
    try {
      await instance.patch(`api/users/withdrawals/status/${id}`, { status });
      setWithdrawalHistory(withdrawalHistory.filter((item) => item._id !== id));
      message.success(`Withdrawal ${status} successfully!`);
    } catch (error) {
      console.error(`Error updating withdrawal status to ${status}:`, error);
      message.error(`Failed to ${status} withdrawal.`);
    }
  };

  // ✅ New Handler for Auto Deposit Approve/Reject
  const handleAutoDepositAction = async (id, status, userId, amount) => {
    try {
        // Assuming this endpoint exists on your backend to update payment status and wallet
        // Please ensure your backend handles /api/userPayment/update-status
        const response = await instance.post("/api/userPayment/update-status", {
            paymentId: id,
            status: status, // "Success" or "Rejected"
            userId: userId,
            amount: amount
        });

        message.success(`Deposit request ${status} successfully`);

        if (status === "Rejected") {
            // Remove from list if rejected
            setAutoDepositHistory((prev) => prev.filter((item) => item._id !== id));
            // Also update fundRequests if present in that list
            setFundRequests((prev) => prev.filter((item) => item._id !== id));
        } else if (status === "Success") {
            // Update status to Success if approved
            setAutoDepositHistory((prev) => 
                prev.map((item) => (item._id === id ? { ...item, status: "Success" } : item))
            );
            setFundRequests((prev) => 
                prev.map((item) => (item._id === id ? { ...item, status: "Success" } : item))
            );
        }
    } catch (error) {
        console.error("Error updating auto deposit status:", error);
        message.error("Failed to update status. Ensure backend API exists.");
    }
  };

  // Calculate Dashboard Stats
  useEffect(() => {
    const calculateDashboardStats = async () => {
      try {
        // Auto Deposit
        const totalAuto = Array.isArray(autoDepositHistory)
          ? autoDepositHistory.reduce((acc, curr) => acc + (curr.amount || 0), 0)
          : 0;
        const dateAuto = Array.isArray(autoDepositHistory)
          ? selectedFilterDate
            ? autoDepositHistory
              .filter((entry) =>
                dayjs(entry.date || new Date()).format("DD-MM-YYYY") === selectedFilterDate
              )
              .reduce((acc, curr) => acc + (curr.amount || 0), 0)
            : totalAuto
          : 0;
        setTotalAutoDeposit(totalAuto);
        setDateTotalAutoDeposit(dateAuto);

        // Manual Deposit
        const totalManual = Array.isArray(data)
          ? data.reduce((acc, curr) => acc + (curr.amount || 0), 0)
          : 0;
        const dateManual = Array.isArray(data)
          ? selectedFilterDate
            ? data
              .filter((entry) =>
                dayjs(entry.date || new Date()).format("DD-MM-YYYY") === selectedFilterDate
              )
              .reduce((acc, curr) => acc + (curr.amount || 0), 0)
            : totalManual
          : 0;
        setTotalManualDeposit(totalManual);
        setDateTotalManualDeposit(dateManual);

        // Bids for Selected Date or All Dates
        const [mainMarketRes, starlineRes, galiDisawarRes] = await Promise.all([
          instance.get(
            selectedFilterDate
              ? `/api/bid/getAllBid?date=${selectedFilterDate}`
              : `/api/bid/getAllBid`
          ),
          instance.get(
            selectedFilterDate
              ? `/api/Starlinebid/getallbid?date=${selectedFilterDate}`
              : `/api/Starlinebid/getallbid`
          ),
          instance.get(
            selectedFilterDate
              ? `/api/GaliDisawarbid/getAllbid?date=${selectedFilterDate}`
              : `/api/GaliDisawarbid/getAllbid`
          ),
        ]);

        const bidArray = mainMarketRes?.data || [];
        const starlineArray = starlineRes?.data || [];
        const galiArray = galiDisawarRes?.data || [];

        const totalMain = Array.isArray(bidArray)
          ? bidArray.reduce((acc, curr) => acc + (curr.points || 0), 0)
          : 0;
        const totalStarline = Array.isArray(starlineArray)
          ? starlineArray.reduce((acc, curr) => acc + (curr.points || 0), 0)
          : 0;
        const totalGali = Array.isArray(galiArray)
          ? galiArray.reduce((acc, curr) => acc + (curr.points || 0), 0)
          : 0;
        const dateTotal = totalMain + totalStarline + totalGali;

        // Withdrawals for Selected Date or All Dates
        const withdrawRes = await instance.get(
          selectedFilterDate
            ? `/api/users/withdrawals?date=${selectedFilterDate}`
            : `/api/users/withdrawals`
        );
        const filteredWithdrawals = Array.isArray(withdrawRes.data)
          ? selectedFilterDate
            ? withdrawRes.data.filter(
              (w) =>
                w.status === "approved" &&
                moment(w.createdAt || new Date()).format("DD-MM-YYYY") === selectedFilterDate
            )
            : withdrawRes.data.filter((w) => w.status === "approved")
          : [];
        const totalWithdrawals = filteredWithdrawals.reduce(
          (acc, curr) => acc + Number(curr.amount || 0),
          0
        );

        setAdminData({
          totalMainMarketBidAmount: totalMain,
          totalStarlineBidAmount: totalStarline,
          totalGaliDisawarBidAmount: totalGali,
          dateTotalBidAmount: dateTotal,
          dateWithdrawalAmount: totalWithdrawals,
        });
      } catch (error) {
        console.error("❌ Error calculating dashboard stats:", error);
      }
    };

    calculateDashboardStats();
  }, [autoDepositHistory, data, selectedFilterDate]);

  // Table Columns
  const withdrawalColumns = [
    {
      title: "#",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      key: "payment_method",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => status.charAt(0).toUpperCase() + status.slice(1),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        if (record.status === "approved" || record.status === "rejected") {
          return <span style={{ fontWeight: "bold" }}>Action Taken</span>;
        }
        return (
          <>
            <button
              onClick={() => handleStatusChange(record._id, "approved")}
              style={{
                marginRight: "8px",
                backgroundColor: "#1677FF",
                color: "white",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Accept
            </button>
            <button
              onClick={() => handleStatusChange(record._id, "rejected")}
              style={{
                backgroundColor: "#F14646",
                color: "white",
                border: "none",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Reject
            </button>
          </>
        );
      },
    },
  ];

  // ✅ Updated Fund Request Columns to include Approve/Reject Buttons
  const fundRequestColumns = [
    {
      title: "#",
      key: "serial",
      render: (text, record, index) => index + 1,
    },
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Txn ID",
      dataIndex: "txnId",
      key: "txnId",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "date",
      render: (createdAt) => moment(createdAt || new Date()).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Action / Status",
      key: "type",
      render: (_, record) => {
        // Only show buttons if NOT success and NOT rejected (assuming "Pending" or other statuses)
        if (record.status === "Success" || record.status === "Approved") {
            return <Button type="primary" style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}>Success</Button>;
        }
        if (record.status === "Rejected") {
            return <Button type="primary" danger disabled>Rejected</Button>;
        }
        
        return (
            <div style={{ display: 'flex', gap: '8px' }}>
                <Button 
                    type="primary" 
                    style={{ backgroundColor: "#1677FF" }}
                    onClick={() => handleAutoDepositAction(record._id, "Success", record.userId, record.amount)}
                >
                    Approve
                </Button>
                <Button 
                    danger
                    onClick={() => handleAutoDepositAction(record._id, "Rejected", record.userId, record.amount)}
                >
                    Reject
                </Button>
            </div>
        );
      },
    },
  ];

  const fundRequestColumnsManualDeposit = [
    {
      title: "#",
      key: "serial",
      render: (text, record, index) => index + 1,
    },
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Txn ID",
      dataIndex: "transactionId",
      key: "transactionId",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "date",
      render: (createdAt) => moment(createdAt || new Date()).format("DD-MM-YYYY HH:mm:ss"),
    },
    {
      title: "Type",
      key: "type",
      render: (_, record) => (
        <Button type="primary" style={{ marginRight: 8 }}>
          {record.status}
        </Button>
      ),
    },
  ];

  const profitLossColumns = [
    {
      title: "Deposit",
      dataIndex: "deposit",
      key: "deposit",
    },
    {
      title: "Withdraw",
      dataIndex: "withdraw",
      key: "withdraw",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
      render: (result) => {
        const isProfit = result > 0;
        const isLoss = result < 0;
        const bgColor = isProfit ? "#7f56c7" : isLoss ? "#ed583e" : "inherit";
        const textColor = isLoss ? "white" : "black";
        return (
          <div
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "5px",
              borderRadius: "4px",
              textAlign: "center",
            }}
          >
            {isProfit
              ? `Profit: ${result}`
              : isLoss
                ? `Loss: ${Math.abs(result)}`
                : "No Profit/Loss"}
          </div>
        );
      },
    },
  ];

  // New function to handle market refresh time update
  const handleUpdateMarketRefreshTime = async () => {
    if (!marketRefreshTime) {
      message.error("Please select a time first.");
      return;
    }
    setUpdatingRefreshTime(true);
    try {
      const timeString = dayjs(marketRefreshTime).format("HH:mm");
      // This is a placeholder API call. Replace with your actual endpoint.
      const response = await instance.post("/api/admin/settings/updateMarketRefreshTime", {
        refreshTime: timeString,
      });

      if (response.data.success) {
        message.success(`Market refresh time updated to ${timeString} successfully!`);
      } else {
        message.error(response.data.message || "Failed to update refresh time.");
      }
    } catch (error) {
      console.error("Error updating refresh time:", error);
      message.error("An error occurred while updating the refresh time.");
    } finally {
      setUpdatingRefreshTime(false);
    }
  };


  return (
    <div style={{ padding: 5 }}>
      {/* Global Date Filter */}
      <Card style={{ marginBottom: 20 }}>
        <Row gutter={16} align="middle">
          <Col>
            <Title level={5}>Filter Data by Date</Title>
          </Col>
          <Col>
            <DatePicker
              style={{ width: 200 }}
              placeholder="Select Date"
              value={selectedFilterDate ? dayjs(selectedFilterDate, "DD-MM-YYYY") : dayjs()}
              onChange={handleFilterDateChange}
              format="DD-MM-YYYY"
              allowClear
            />
          </Col>
        </Row>
      </Card>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <Spin size="small" />
        </div>
      ) : (
        <Row gutter={[16, 16]}>
          {/* Left Side */}
          <Col xs={24} md={8}>
            <div className="admin-dashboard-card">
              <div className="welcome-card">
                <Title level={3} className="admin-dashboard-title">
                  Welcome Back!
                </Title>
                <p className="admin-dashboard-subtitle">Admin Dashboard</p>
              </div>
              <div className="admin-dashboard-avatar-section">
                <div className="avtr-admin">
                  <Avatar
                    className="admin-dashboard-avatar"
                    src="https://img.icons8.com/?size=256w&id=110479&format=png"
                  />
                  <Title level={3} className="admin-dashboard-name">
                    Admin
                  </Title>
                </div>
                <div className="admin-dashboard-stats">
                  <Text
                    className="admin-dashboard-stats-text"
                    onClick={() => navigate("/admin/user-management/unapproved")}
                  >
                    Unapproved Users: {unapprovedUsers.unapprovedUsers ?? "Failed to fetch"}
                  </Text>
                </div>
                <div className="admin-dashboard-stats">
                  <Text
                    className="admin-dashboard-stats-text"
                    onClick={() => navigate("/admin/user-management/approved")}
                  >
                    Approved Users: {approvedUsers.approvedUsers ?? "Failed to fetch"}
                  </Text>
                </div>
              </div>
            </div>
            <Card style={{ marginTop: 20 }}>
              <Title level={5}>Market Bid Details for {selectedDate}</Title>
              <Row gutter={16}>
                <Col span={24}>
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="Select Date"
                    value={dayjs(selectedDate, "DD-MM-YYYY")}
                    onChange={handleDateChange2}
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </Col>
                <Col span={24} style={{ marginTop: 10 }}>
                  <Select
                    placeholder="Select Game Name"
                    style={{ width: "100%" }}
                    onChange={handleGameChange2}
                  >
                    {mainMarketGamesLeft.map((game) => (
                      <Option key={game._id} value={game.gameName}>
                        {game.gameName}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col
                  span={24}
                  style={{ marginTop: 10, display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    type="primary"
                    onClick={handleSubmit}
                    loading={loadingButton}
                    style={{ backgroundColor: "#349163", color: "white", fontWeight: "bold" }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col style={{ marginTop: "55px" }} span={24}>
                  <div className="dashboard-card-inner">
                    <Row className="dashboard-card-row">
                      <Col className="dashboard-card-col">Total Bid Amount</Col>
                      <Col>
                        <span className="dashboard-card-value">
                          Rs {dashboardData2.totalBidAmount || 0}
                        </span>
                      </Col>
                      {/* <Col>
                        <Button type="primary">View</Button>
                      </Col> */}
                    </Row>
                  </div>
                </Col>
                <Col span={24}>
                  <div className="dashboard-card-inner">
                    <Row className="dashboard-card-row">
                      <Col className="dashboard-card-col">Total Win Amount</Col>
                      <Col>
                        <span className="dashboard-card-value">
                          Rs {dashboardData2.totalWinAmount || 0}
                        </span>
                      </Col>
                      {/* <Col>
                        <Button type="primary">View</Button>
                      </Col> */}
                    </Row>
                  </div>
                </Col>
                <Col span={24}>
                  <div className="dashboard-card-inner profit-card">
                    <Row className="dashboard-card-row">
                      <Col className="dashboard-card-col">Total Profit Amount</Col>
                      <Col>
                        <span className="dashboard-card-value">
                          Rs {dashboardData2.totalProfitAmount || 0}
                        </span>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Card>
            {/* New Card for Market Refresh Time */}
            <Card style={{ marginTop: 20 }}>
              <Title level={5}>Update Market Refresh Time</Title>
              <Row gutter={16} align="middle">
                <Col span={12}>
                  <TimePicker
                    style={{ width: "100%" }}
                    value={marketRefreshTime}
                    onChange={setMarketRefreshTime}
                    format="HH:mm"
                    placeholder="Select Time"
                  />
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    onClick={handleUpdateMarketRefreshTime}
                    loading={updatingRefreshTime}
                    style={{ width: "100%", backgroundColor: "#349163", color: "white", fontWeight: "bold" }}
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            </Card>

          </Col>
          {/* Right Side */}
          <Col xs={24} md={16}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <Card style={{ borderRadius: "5px" }}>
                  <div
                    onClick={() => navigate("/admin/user-management/approved")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>Users</span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {totalUsers.totalUsers ?? "Failed to fetch"}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <UserOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12}>
                <Card style={{ borderRadius: "5px" }}>
                  <div
                    onClick={() => navigate("/admin/game-management/game-name")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>Games (Today)</span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {totalGames.totalGameCount ?? "Failed to fetch"}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <AppstoreOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12}>
                {/* <Card style={{ borderRadius: "5px" }}>
                  <div
                    onClick={() => navigate("/admin/all-bid-history")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Main Market Bid Amount ({selectedFilterDate || "All Dates"})
                      </span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {`₹${mainMarketData.totalAmount}`}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <DollarOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card> */}
              </Col>
              <Col xs={24} sm={12}>
                {/* <Card style={{ borderRadius: "5px" }}>
                  <div
                    onClick={() => navigate("/admin/all-bid-history")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Starline Bid Amount ({selectedFilterDate || "All Dates"})
                      </span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {`₹${starlineData.totalAmount}`}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FundOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card> */}
              </Col>
              <Col xs={24} sm={12}>
                {/* <Card style={{ borderRadius: "5px" }}>
                  <div
                    onClick={() => navigate("/admin/all-bid-history")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Total Auto Deposit ({selectedFilterDate || "All Dates"})
                      </span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        ₹{dateTotalAutoDeposit}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FundOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card> */}
              </Col>
              <Col xs={24} sm={12}>
                {/* <Card style={{ borderRadius: "5px" }}>
                  <div
                    onClick={() => navigate("/admin/all-bid-history")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Total Manual Deposit ({selectedFilterDate || "All Dates"})
                      </span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {`₹${dateTotalManualDeposit}`}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FundOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card> */}
              </Col>
              <Col xs={24} sm={12}>
                <Card style={{ borderRadius: "5px" }}>
                  <div
                    // onClick={() => navigate("/admin/user-management")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Today's Registrations
                      </span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {registrationStats.todayRegistrations}
                      </div>
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        Total admins: {registrationStats.totalRegistrations}
                      </div>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#52c41a",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <UserOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xs={24} sm={12}>
                <Card style={{ borderRadius: "5px" }}>
                  <div
                    // onClick={() => navigate("/admin/login-activity")}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Today's Logins
                      </span>
                      <div style={{ fontWeight: "bold", fontSize: "20px" }}>
                        {loginStats.todayLoginCount}
                      </div>
                      {/* <div style={{ fontSize: "12px", color: "#666" }}>
                        Active sessions: {loginStats.totalActiveSessions}
                      </div> */}
                    </div>
                    <div
                      style={{
                        backgroundColor: "#1890ff",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <UserOutlined style={{ color: "#fff", fontSize: "24px" }} />
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
            <Card style={{ marginTop: 20 }}>
              <Title level={5}>
                Total Bids on Single Ank of {selectedFilterDate || "All Dates"}
              </Title>
              <Row gutter={16} align="middle">
                <Col span={6}>
                  <Select
                    placeholder="Select Game Name"
                    style={{ width: "100%" }}
                    onChange={handleGameChange}
                  >
                    {mainMarketGames.map((game) => (
                      <Option key={game._id} value={game.gameName}>
                        {game.gameName}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="Select Session"
                    style={{ width: "100%" }}
                    onChange={handleSessionChange}
                  >
                    <Option value="open">Open</Option>
                    <Option value="close">Close</Option>
                  </Select>
                </Col>
                <Col span={6}>
                  <Select
                    placeholder="Game Type"
                    style={{ width: "100%" }}
                    onChange={(value) => setSelectedGameType(value)}
                  >
                    {betRates.map((gameType, index) => (
                      <Option key={index} value={gameType}>
                        {gameType}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={4}>
                  <Button
                    className="min-w-full"
                    type="primary"
                    onClick={handleGetClick}
                    loading={loadingButton2}
                  >
                    Get
                  </Button>
                </Col>
              </Row>
            </Card>
            <div className="card-container">
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((ank) => {
                const hue = 36 * ank;
                const color = `hsl(${hue}, 60%, 50%)`;

                // Check if dashboardData exists and has the digit data
                const digitData = dashboardData[ank] || {
                  totalUsers: 0,
                  totalAmount: 0
                };

                return (
                  <div className="card" key={ank} style={{ borderColor: color }}>
                    <p className="card-text mt-2">Today Bids: {digitData.totalUsers || 0}</p>
                    <h4 className="card-title">₹{digitData.totalAmount || 0}</h4>
                    <span className="font-bold">Total Bid Amount</span>
                    <button className="card-btn" style={{ backgroundColor: color }}>
                      Ank {ank}
                    </button>
                  </div>
                );
              })}
            </div>
            <Card style={{ marginTop: 20, width: "100%" }}>
              <Title level={5}>
                Profit/Loss Report for {selectedFilterDate || "All Dates"}
              </Title>
              {loadingButton3 ? (
                <Spin />
              ) : error ? (
                <p>{error}</p>
              ) : (
                <Table
                  columns={profitLossColumns}
                  dataSource={profitLossData}
                  pagination={false}
                  rowKey="key"
                  scroll={{ x: 800 }}
                />
              )}
            </Card>
          </Col>
        </Row>
      )}
      {/* Auto Deposit History */}
      <Card
        style={{ marginTop: 20, width: "100%" }}
        extra={
          <Button
            type="link"
            onClick={() => setShowAutoDepositHistory(!showAutoDepositHistory)}
            icon={showAutoDepositHistory ? <UpOutlined /> : <DownOutlined />}
          >
            {showAutoDepositHistory ? "Hide" : "Show"} Auto Deposit History
          </Button>
        }
      >
        <Collapse activeKey={showAutoDepositHistory ? ["1"] : []} ghost>
          <Collapse.Panel
            header={
              <Title level={5} style={{ marginBottom: 0 }}>
                Fund Request Auto Deposit History for {selectedFilterDate || "All Dates"}
              </Title>
            }
            key="1"
            showArrow={false}
          >
            {loading ? (
              <Spin />
            ) : error ? (
              <p>{error}</p>
            ) : (
              <Table
                columns={fundRequestColumns}
                dataSource={autoDepositHistory}
                rowKey="_id"
                scroll={{ x: true }}
                pagination={{ pageSize: 10 }}
              />
            )}
          </Collapse.Panel>
        </Collapse>
      </Card>
      {/* Manual Deposits */}
      <Card
        style={{ marginTop: 20, width: "100%" }}
        extra={
          <Button
            type="link"
            onClick={() => setShowManualDeposits(!showManualDeposits)}
            icon={showManualDeposits ? <UpOutlined /> : <DownOutlined />}
          >
            {showManualDeposits ? "Hide" : "Show"} Manual Deposits
          </Button>
        }
      >
        <Collapse activeKey={showManualDeposits ? ["1"] : []} ghost>
          <Collapse.Panel
            header={
              <Title level={5} style={{ marginBottom: 0 }}>
                Fund Request Manual Deposits History for {selectedFilterDate || "All Dates"}
              </Title>
            }
            key="1"
            showArrow={false}
          >
            {loading ? (
              <Spin />
            ) : error ? (
              <p>{error}</p>
            ) : (
              <Table
                columns={fundRequestColumnsManualDeposit}
                dataSource={data}
                rowKey="_id"
                scroll={{ x: true }}
                pagination={{ pageSize: 5 }}
              />
            )}
          </Collapse.Panel>
        </Collapse>
      </Card>
      {/* Withdrawals */}
      <Card
        style={{ marginTop: 20, width: "100%" }}
        extra={
          <Button
            type="link"
            onClick={() => setShowWithdrawals(!showWithdrawals)}
            icon={showWithdrawals ? <UpOutlined /> : <DownOutlined />}
          >
            {showWithdrawals ? "Hide" : "Show"} Withdrawals
          </Button>
        }
      >
        <Collapse activeKey={showWithdrawals ? ["1"] : []} ghost>
          <Collapse.Panel
            header={
              <Title level={5} style={{ marginBottom: 0 }}>
                Withdraw Request History for {selectedFilterDate || "All Dates"}
              </Title>
            }
            key="1"
            showArrow={false}
          >
            {loading ? (
              <Spin />
            ) : error ? (
              <p>{error}</p>
            ) : (
              <Table
                columns={withdrawalColumns}
                dataSource={withdrawalHistory}
                rowKey="_id"
                scroll={{ x: true }}
                pagination={{ pageSize: 10 }}
              />
            )}
          </Collapse.Panel>
        </Collapse>
      </Card>
      {/* Fund Requests */}
      <Card
        style={{ marginTop: 20, width: "100%" }}
        extra={
          <Button
            type="link"
            onClick={() => setShowFundRequests(!showFundRequests)}
            icon={showFundRequests ? <UpOutlined /> : <DownOutlined />}
          >
            {showFundRequests ? "Hide" : "Show"} Fund Requests
          </Button>
        }
      >
        <Collapse activeKey={showFundRequests ? ["1"] : []} ghost>
          <Collapse.Panel
            header={
              <Title level={5} style={{ marginBottom: 0 }}>
                Fund Request History for {selectedFilterDate || "All Dates"}
              </Title>
            }
            key="1"
            showArrow={false}
          >
            {loading ? (
              <Spin />
            ) : error ? (
              <p>{error}</p>
            ) : (
              <Table
                columns={fundRequestColumns}
                dataSource={fundRequests}
                rowKey="_id"
                scroll={{ x: true }}
                pagination={{ pageSize: 10 }}
              />
            )}
          </Collapse.Panel>
        </Collapse>
      </Card>
    </div>
  );
};

export default Dashboard;